import { getTenantFromHostname } from "../utils/environment";

let currentTenant: string | null = null;

export const setTenantHeader = (tenant: string | null) => {
  currentTenant = tenant;
};

export const getTenantHeader = () => {
  return currentTenant;
};

/** Aligns in-memory header with hostname tenant when nothing selected yet. */
export const seedTenantFromHostname = (
  readHost: () => string | null = getTenantFromHostname
): string | null => {
  const tenant = currentTenant ?? readHost();
  if (tenant) setTenantHeader(tenant);
  return tenant;
};
